(() => {
  function init(root) {
    if (!root || root.dataset.soReady) return;
    root.dataset.soReady = 'true';
    const sectionId = root.dataset.section;
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const productForm = form?.closest('product-form');
    if (productForm?.hasAttribute('data-styleomg-cart-page')) productForm.cart = null;
    if (form) {
      form.addEventListener('submit', (event) => {
        const invalid = Array.from(form.elements).find(el => el.willValidate && !el.checkValidity());
        if (!invalid) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        invalid.reportValidity();
        invalid.focus();
        const sticky = root.querySelector('sticky-atc');
        sticky?.setLoading?.(false);
      }, true);
    }
    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-so-media-step]');
      if (!button) return;
      const gallery = button.closest('media-gallery');
      const items = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
      const current = Math.max(0, items.findIndex(el => el.classList.contains('is-active')));
      const next = (current + Number(button.dataset.soMediaStep) + items.length) % items.length;
      gallery.setActiveMedia?.(items[next].dataset.mediaId, false);
    });
    const summary = root.querySelector('[data-so-selected-variant]');
    const applySummary = () => {
      const picker = root.querySelector('variant-selects');
      picker?.querySelectorAll('fieldset').forEach((group, index) => {
        const input = group.querySelector('input:checked');
        const target = summary?.querySelector(`[data-so-summary-option="${index}"]`);
        if (target && input) target.textContent = input.value;
      });
    };
    root.addEventListener('change', (event) => {
      if (event.target.closest('variant-selects')) applySummary();
    });
    if (typeof subscribe === 'function') {
      const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (!root.isConnected) { unsubscribe(); return; }
        if (data.sectionId !== sectionId) return;
        applySummary();
        const source = data.html?.querySelector('[data-so-size-guide]');
        if (source) root.querySelectorAll('[data-so-size-guide]').forEach(el => el.innerHTML = source.innerHTML);
      });
    }
    applySummary();
  }
  function scan(scope = document) {
    if (scope.matches?.('.styleomg-pdp')) init(scope);
    scope.querySelectorAll('.styleomg-pdp').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => scan(), { once: true });
  else scan();
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('product-info:loaded', (event) => scan(event.target));
})();
(() => {
  function bind(track) {
    if (track.dataset.bound || !track.dataset.autoplay || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    track.dataset.bound = 'true';
    let paused = false;
    track.addEventListener('mouseenter', () => paused = true);
    track.addEventListener('mouseleave', () => paused = false);
    track.addEventListener('focusin', () => paused = true);
    track.addEventListener('focusout', () => paused = false);
    const timer = setInterval(() => {
      if (!track.isConnected) { clearInterval(timer); return; }
      if (paused || document.hidden || track.scrollWidth <= track.clientWidth + 1) return;
      track.scrollTo({ left: track.scrollLeft + track.clientWidth >= track.scrollWidth - 2 ? 0 : track.scrollLeft + track.clientWidth, behavior: 'smooth' });
    }, Math.max(2000, Number(track.dataset.autoplay)));
  }
  const scan = () => document.querySelectorAll('[data-so-carousel]').forEach(bind);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
